import { createRoute, useNavigate } from "@tanstack/react-router";
import { FormEvent, useState } from "react";

import { useAuth } from "../auth/AuthContext";
import { rootRoute } from "./__root";

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/change-password",
  component: ChangePasswordScreen,
});

function ChangePasswordScreen() {
  const { accessToken, logout } = useAuth();
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    if (newPassword.length < 8) return setError("New password must be at least 8 characters.");
    if (newPassword !== confirmPassword) return setError("Passwords do not match.");
    setBusy(true);
    setError("");
    const res = await fetch("/api/auth/change-password", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify({ current_password: currentPassword, new_password: newPassword }),
    });
    setBusy(false);
    if (!res.ok) {
      const payload = await res.json().catch(() => ({ error: "Password change failed" }));
      return setError(payload.error || "Password change failed");
    }
    await logout();
    return navigate({ to: "/login" });
  }

  return (
    <main className="flex min-h-screen items-center justify-center bg-slate-100 px-4">
      <form onSubmit={submit} className="w-full max-w-sm rounded-lg border bg-white p-6 shadow-sm">
        <h1 className="text-2xl font-semibold text-slate-950">Change password</h1>
        <p className="mt-1 text-sm text-slate-600">Required before entering the dashboard.</p>
        <input className="mt-5 w-full rounded-md border px-3 py-2 text-sm" type="password" placeholder="Current password" value={currentPassword} onChange={(event) => setCurrentPassword(event.target.value)} />
        <input className="mt-3 w-full rounded-md border px-3 py-2 text-sm" type="password" placeholder="New password" value={newPassword} onChange={(event) => setNewPassword(event.target.value)} />
        <input className="mt-3 w-full rounded-md border px-3 py-2 text-sm" type="password" placeholder="Confirm new password" value={confirmPassword} onChange={(event) => setConfirmPassword(event.target.value)} />
        {error ? <div className="mt-4 rounded-md bg-red-50 px-3 py-2 text-sm text-red-700">{error}</div> : null}
        <button className="mt-5 w-full rounded-md bg-slate-950 px-3 py-2 text-sm font-semibold text-white disabled:opacity-60" disabled={busy} type="submit">
          {busy ? "Saving..." : "Save password"}
        </button>
      </form>
    </main>
  );
}
